import React, { Fragment } from "react";
import PropTypes from "prop-types";
import createMarkup from "../../helpers/createMarkup";
import Section from "../common/Section";
import IconGroup from "../common/icon/IconGroup";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconList, menuList1 } from "../../helpers/data/footer";
import { animateScroll } from "react-scroll";
import menuList3 from "../../helpers/data/footer/menuList3";
import { version } from "../../config";
import Logo from "../navbar/Logo";

const FooterTitle = ({ children }) => (
  <h5 className="text-uppercase text-white opacity-85 mb-3">{children}</h5>
);

FooterTitle.propTypes = { children: PropTypes.node.isRequired };

const FooterList = ({ list }) => (
  <ul className="list-unstyled">
    {list.map(({ title, to }, index) => (
      <li className="mb-1" key={index}>
        <Link className="text-white" to={to}>
          {title}
        </Link>
      </li>
    ))}
  </ul>
);

const FooterListInfo = ({ list }) => (
  <ul className="list-unstyled">
    {list.map(({ title, to }, index) => (
      <li className="mb-1" key={index} style={{ color: "#FFFFFF" }}>
        {title}
      </li>
    ))}
  </ul>
);

FooterList.propTypes = { list: PropTypes.array.isRequired };

const FooterBlogList = ({ list }) => (
  <ul className="list-unstyled">
    {list.map((blog, index) => (
      <li key={index}>
        <h5 className="fs-0 mb-0">
          <Link className="text-600" to="#!">
            {blog.title}
          </Link>
        </h5>
        <p className="text-600 opacity-50">
          {blog.date} &bull; {blog.read} read{" "}
          {blog.star && (
            <span dangerouslySetInnerHTML={createMarkup("&starf;")} />
          )}
        </p>
      </li>
    ))}
  </ul>
);

FooterBlogList.propTypes = { list: PropTypes.array.isRequired };

const FooterStandard = () => (
  <>
    <Section style={{ background: "#260532" }} className="pt-8 pb-4">
      <div
        style={{ background: "#260532" }}
        className="position-absolute btn-back-to-top cursor-pointer"
        onClick={animateScroll.scrollToTop}
      >
        <FontAwesomeIcon
          icon="chevron-up"
          transform="rotate-45"
          className="text-600"
        />
      </div>
      <Row className="mb-5">
        <Col lg={12}>
          {" "}
          <Logo at="navbar-top" bordered width={150} id="topLogo" />
        </Col>
      </Row>
      <Row>
        <Col lg={4}>
          <FooterTitle>Nuestra misión</FooterTitle>
          <p className="text-white">
            <b className="mr-1">Homelan</b>
            permite optimizar la gestión de los procesos cotidianos del hogar y
            la comunidad de manera organizada, rápida y eficiente, mediante
            procesos automatizados.
          </p>
          <IconGroup className="mt-4" icons={iconList} />
        </Col>
        <Col className="pl-lg-6 pl-xl-8">
          <Row className="mt-5 mt-lg-0">
            <Col xs={12} md={6}>
              <FooterTitle>Acerca de nosotros</FooterTitle>
              <FooterList className="m-0" list={menuList1} />
            </Col>
            {/*             <Col xs={6} md={3}>
              <FooterTitle>Compañía</FooterTitle>
              <FooterList className="m-0" list={menuList1} />
            </Col> */}
            <Col className="mt-5 mt-md-0">
              <FooterTitle>Información de contacto</FooterTitle>
              <FooterListInfo className="m-0" list={menuList3} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Section>
    <section
      style={{ background: "#260532" }}
      className="py-0 text-center fs--1"
    >
      <hr className="my-0 border-600 opacity-25" />
      <div className="container py-3">
        <Row className="justify-content-between">
          <Col xs={12} sm="auto">
            <p className="mb-0 text-600 text-white">
              &copy;{new Date().getFullYear()} Grupo Homelan, C.A. J-508676335
            </p>
          </Col>
          <Col xs={12} sm="auto">
            <p className="mb-0 text-600 text-white">v{version}</p>
          </Col>
        </Row>
      </div>
    </section>
  </>
);

export default FooterStandard;
